export const enAU = {
  abnEntity: 'an Australian Business Number',
  abn: 'ABN',
  abnLowercase: 'ABN',
  abnSearchName: 'Australian Business Register',
  abns: 'ABNs',
  abnsLowercase: 'ABNs',
  companyInduction: 'Company Induction',
  companyInductions: 'Company Inductions',
  defect: 'Defect',
  defects: 'Defects',
  drawing: 'Drawing',
  drawings: 'Drawings',
  favourite: 'Favourite',
  favourites: 'Favourites',
  induct: 'Induct',
  inducts: 'Inducts',
  inducted: 'Inducted',
  inducting: 'Inducting',
  induction: 'Induction',
  inductions: 'Inductions',
  itp: 'ITP',
  itps: 'ITPs',
  people: 'People',
  peoples: 'People',
  preStart: 'Pre-start',
  preStarts: 'Pre-starts',
  projectHoursBudget: 'Project Hours Budget',
  projectHoursBudgets: 'Project Hours Budgets',
  project: 'Project',
  projects: 'Projects',
  placeholderAddress: '123 Collins St, Melbourne 3000',
  placeholderProjectName: '123 Collins St',
  placeholderPhoneNumber: '0412 345 678',
  register: 'Register',
  registers: 'Registers',
  sdsLibrary: 'SDS Library',
  sdsLibraries: 'SDS Libraries',
  signOn: 'Sign On',
  signOns: 'Sign Ons',
  siteInduction: 'Site Induction',
  siteInductions: 'Site Inductions',
  siteDiary: 'Site Diary',
  siteDiaries: 'Site Diaries',
  staff: 'Staff',
  staffs: 'Staffs',
  subcontractor: 'Company',
  subcontractors: 'Companies',
  swms: 'SWMS',
  swmss: 'SWMS', // plural, see en-US for example where it matters
  swmsFullTitle: 'Safe Work Method Statement',
  ticket: 'Certification',
  tickets: 'Certifications',
  timesheet: 'Timesheet',
  timesheets: 'Timesheets',
  worker: 'Worker',
  workers: 'Workers',
}
